/* eslint-disable jsx-a11y/alt-text */
import { shouldShowDataExportMenu } from '../../utils/functions/dataExportAccess';
import React, { useState, useEffect, useContext } from 'react'; //
import { styled, alpha } from '@mui/material/styles'; // <--- เพิ่ม alpha
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { NavLink, useLocation } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ImageListItem from '@mui/material/ImageListItem';
import RestoreIcon from '@mui/icons-material/Restore';
import {
  Box,
  useMediaQuery,
  useTheme,
  Hidden,
  Button,
  Divider,
} from '@mui/material'; // <--- เพิ่ม Divider
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';
import ManageHistoryOutlinedIcon from '@mui/icons-material/ManageHistoryOutlined';
import PendingActionsOutlinedIcon from '@mui/icons-material/PendingActionsOutlined';
import Collapse from '@mui/material/Collapse';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import DataUsageIcon from '@mui/icons-material/DataUsage';
import LoginIcon from '@mui/icons-material/Login';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import inetlogo from '../../assets/images/inetlogo.png';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import SummarizeIcon from '@mui/icons-material/Summarize';
import PlagiarismIcon from '@mui/icons-material/Plagiarism';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';

// Imports จาก Sidebar (ไฟล์ 1)
import ManualSpeedDial from '../ManualSpeedDial';
import { PassportAuth } from '../../contexts/AuthContext';
import LogoutIcon from '@mui/icons-material/Logout';
import { useTranslation } from 'react-i18next';
import LanguageIcon from '@mui/icons-material/Language';
import { useNavigate } from 'react-router-dom';

const drawerWidth = 250;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

// --- Component หลัก ---
export default function SidebarAdmin({
  open,
  setOpen,
  openMobile,
  onMobileClose,
}) {
  const location = useLocation();
  const theme = useTheme();

  // Logic จาก Sidebar (ไฟล์ 1)
  const { t } = useTranslation(); // <-- t ถูกสร้างตรงนี้
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const toggleLanguage = () => {
    const newLang = lang === 'th' ? 'en' : 'th';
    i18n.changeLanguage(newLang);
  };
  const { handleAdminSignout } = useContext(PassportAuth);
  const navigate = useNavigate();

  // State สำหรับเมนูย่อย (จาก SidebarAdmin)
  const [openListPayment, setOpenListPayment] = useState(false);
  const [openListUsage, setOpenListUsage] = useState(false);
  const [openListStatement, setOpenListStatement] = useState(false);
  const [openListTrans, setOpenListTrans] = useState(false);

  // --- Menu Items (ย้ายมาไว้ตรงนี้) ---
  const items = [
    {
      href: '/invoice-main',
      icon: AssignmentOutlinedIcon,
      title: t('app.invoicePrepaid'), // <--- ใช้งานได้แล้ว
      id: 1,
      sub: [],
    },
    {
      href: '/waiting-for-payment',
      icon: AccessTimeOutlinedIcon,
      title: t('app.pendingPayments'),
      id: 2,
      sub: [],
    },
    {
      href: '/payment-history',
      icon: RestoreIcon,
      title: t('app.paymentHistory'),
      id: 3,
      sub: [],
    },
    ...(shouldShowDataExportMenu() ? [{
      href: '/data-export',
      icon: CloudDownloadOutlinedIcon,
      title: 'Data Export',
      id: 4,
      sub: [],
    }] : []),
    {
      icon: ReceiptOutlinedIcon,
      title: t('app.paymentProof'),
      key: 'paymentEvidence',
      id: 5,
      sub: [
        {
          id: 51,
          label: t('app.pendingStatus'),
          icon: AccessTimeOutlinedIcon,
          href: '/pending',
        },
        {
          id: 52,
          label: t('app.approvedStatus'),
          icon: TaskAltOutlinedIcon,
          href: '/approved',
        },
        {
          id: 53,
          label: t('app.rejectedStatus'),
          icon: CancelOutlinedIcon,
          href: '/rejected',
        },
        {
          id: 53, // หมายเหตุ: id ซ้ำกับด้านบน
          label: t('app.activityHistory'),
          icon: SummarizeIcon,
          href: '/Report',
        },
      ],
    },
    {
      href: '/CustomerManage',
      icon: PlagiarismIcon,
      title: t('app.customerManage'),
      id: 6,
      sub: [],
    },
    {
      href: '/Matching-Main',
      icon: DoneAllOutlinedIcon,
      title: t('app.matching'),
      id: 6, // หมายเหตุ: id ซ้ำกับด้านบน
      sub: [],
    },
    {
      href: '/ReportMatch',
      icon: SummarizeOutlinedIcon,
      title: t('app.reportMatched'),
      id: 7,
      sub: [],
    },
    {
      href: '/ReportUnmatch-Main',
      icon: ManageHistoryOutlinedIcon,
      title: t('app.reportUnmatch'),
      id: 8,
      sub: [],
    },
    {
      icon: PendingActionsOutlinedIcon,
      title: t('app.statementOnlineTitle'),
      key: 'statementOnline',
      id: 11,
      sub: [
        {
          id: 111,
          label: t('app.statementOnlineTitle'),
          icon: PendingActionsOutlinedIcon,
          href: '/online-statement',
        },
        {
          id: 112,
          label: t('app.logStatement'),
          icon: TaskAltOutlinedIcon,
          href: '/log-statement',
        },
      ],
    },
    {
      icon: DataUsageIcon,
      title: t('app.history'),
      key: 'usageHistory',
      id: 9,
      sub: [
        {
          id: 91,
          label: t('app.logLogin'),
          icon: LoginIcon,
          href: '/Usage-history-login',
        },
        {
          id: 92,
          label: t('app.logDownloadInvoice'),
          icon: FileCopyIcon,
          href: '/Usage-history-invoices',
        },
        {
          id: 93,
          label: t('app.logDownloadReceipt'),
          icon: ReceiptIcon,
          href: '/Usage-history-Receipt',
        },
        {
          id: 94,
          label: t('app.logCreditNote'),
          icon: RequestQuoteIcon,
          href: '/Usage-history-creditNote',
        },
        {
          id: 95,
          label: t('app.logUpload'),
          icon: CloudUploadIcon,
          href: '/Usage-history-Upload',
        },
        {
          id: 95, // หมายเหตุ: id ซ้ำกับด้านบน
          label: t('app.logWht'),
          icon: FactCheckIcon,
          href: '/Withholding',
        },
      ],
    },
    {
      icon: FileCopyIcon,
      title: t('app.transactions'),
      key: 'transactions',
      id: 10,
      sub: [
        {
          id: 101,
          label: t('app.billPayment'),
          icon: PendingActionsOutlinedIcon,
          href: '/bill-payment',
        },
        {
          id: 102,
          label: t('app.offlinePayment'),
          icon: TaskAltOutlinedIcon,
          href: '/offline-payment',
        },
      ],
    },
  ];

  const renderMenuItems = (
    open,
    location,
    openListPayment,
    setOpenListPayment,
    openListUsage,
    setOpenListUsage,
    openListStatement,
    setOpenListStatement,
    openListTrans,
    setOpenListTrans,
  ) => (
    <List sx={{ p: 1 }}>
      {' '}
      {/* <--- 1. เพิ่ม Padding รอบนอก */}
      {items.map((item) => {
        const isActive = item.href === location.pathname;
        const hasSub = item.sub.length > 0;
        const isOpen = {
          paymentEvidence: openListPayment,
          usageHistory: openListUsage,
          statementOnline: openListStatement,
          transactions: openListTrans,
        }[item.key];

        const toggleOpen = () => {
          switch (item.key) {
            case 'paymentEvidence':
              setOpenListPayment(!openListPayment);
              break;
            case 'usageHistory':
              setOpenListUsage(!openListUsage);
              break;
            case 'statementOnline':
              setOpenListStatement(!openListStatement);
              break;
            case 'transactions':
              setOpenListTrans(!openListTrans);
              break;
            default:
              break;
          }
        };

        return (
          <React.Fragment key={item.title}>
            <ListItem sx={{ display: 'block', px: 0 }}>
              {item.href && !hasSub ? (
                <NavLink to={item.href}>
                  <ListItemButton
                    sx={{
                      height: 44,
                      justifyContent: open ? 'initial' : 'center',
                      borderRadius: '12px',
                      my: 0.5,
                      px: 2.5,
                      backgroundColor: isActive
                        ? alpha(theme.palette.primary.main, 0.1)
                        : 'inherit',
                      color: isActive ? 'primary.main' : 'inherit',
                      '&:hover': {
                        backgroundColor: alpha(
                          theme.palette.primary.main,
                          0.05,
                        ),
                      },
                    }}
                  >
                    <ListItemIcon
                      sx={{
                        minWidth: 5,
                        mr: open ? 2 : 'auto',
                        justifyContent: 'center',
                        color: isActive ? 'primary.main' : 'inherit', 
                      }}
                    >
                      <item.icon />
                    </ListItemIcon>
                    <ListItemText
                      primary={item.title}
                      sx={{ opacity: open ? 1 : 0 }}
                      primaryTypographyProps={{
                        // <--- 5. ปรับ Font เมนูหลัก
                        fontWeight: 600,
                        fontSize: '0.95rem',
                      }}
                    />
                  </ListItemButton>
                </NavLink>
              ) : (
                <ListItemButton
                  onClick={toggleOpen}
                  sx={{
                    height: 44, // <--- 3. ปรับสไตล์ปุ่ม (ที่มี sub)
                    justifyContent: open ? 'initial' : 'center',
                    borderRadius: '12px',
                    my: 0.5,
                    px: 2.5,
                    color: isOpen ? 'primary.main' : 'inherit',
                  }}
                >
                  <ListItemIcon
                    sx={{
                      minWidth: 5,
                      mr: open ? 2 : 'auto',
                      justifyContent: 'center',
                    }}
                  >
                    <item.icon />
                  </ListItemIcon>
                  <ListItemText
                    primary={item.title}
                    sx={{ opacity: open ? 1 : 0 }}
                    primaryTypographyProps={{
                      // <--- 5. ปรับ Font เมนูหลัก
                      fontWeight: 600,
                      fontSize: '0.95rem',
                    }}
                  />
                  {hasSub && (isOpen ? <ExpandLess /> : <ExpandMore />)}
                </ListItemButton>
              )}
            </ListItem>

            {hasSub && (
              <Collapse in={isOpen} timeout="auto" unmountOnExit>
                <List
                  component="div"
                  disablePadding
                  sx={{ mt: 0.5 }} // <--- 6. ปรับสไตล์ List ของ Sub
                >
                  {item.sub.map((subItem) => {
                    const isSubActive = subItem.href === location.pathname;
                    return (
                      <NavLink key={subItem.label} to={subItem.href}>
                        <ListItemButton
                          sx={{
                            height: 40, // <--- 7. ปรับสไตล์ปุ่ม Sub
                            justifyContent: open ? 'initial' : 'center',
                            pl: open ? 5 : 2.5,
                            pr: 2.5,
                            my: 0.25,
                            borderRadius: '12px',
                            backgroundColor: isSubActive
                              ? alpha(theme.palette.primary.main, 0.1)
                              : 'inherit',
                            color: isSubActive ? 'primary.main' : 'inherit',
                            '&:hover': {
                              backgroundColor: alpha(
                                theme.palette.primary.main,
                                0.05,
                              ),
                            },
                          }}
                        >
                          <ListItemIcon
                            sx={{
                              minWidth: 5,
                              mr: open ? 2 : 'auto',
                              justifyContent: 'center',
                              color: isSubActive ? 'primary.main' : 'inherit', // <--- 8. สีไอคอน Sub
                            }}
                          >
                            <subItem.icon sx={{ fontSize: '1.25rem' }} />
                          </ListItemIcon>
                          <ListItemText
                            primary={subItem.label}
                            primaryTypographyProps={{
                              // <--- 9. นี่คือจุดที่แก้ขนาดอักษร Sub
                              fontSize: '0.875rem',
                            }}
                          />
                        </ListItemButton>
                      </NavLink>
                    );
                  })}
                </List>
              </Collapse>
            )}
          </React.Fragment>
        );
      })}
    </List>
  );

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const extraControls = (
    <div className="flex justify-end md:hidden p-4 mt-auto">
      <div>
        {' '}
        <Button onClick={toggleLanguage}>
          <LanguageIcon />
          {lang === 'th' ? 'TH' : 'EN'}
        </Button>{' '}
      </div>

      <Button
        color="error"
        size="small"
        onClick={() => {
          handleAdminSignout();
          navigate('/login-admin');
        }}
      >
        <LogoutIcon />
      </Button>
    </div>
  );

  // --- ส่วนหัว Logo (สำหรับ Desktop) ---
  const desktopLogo = (
    <ListItem
      disablePadding
      sx={{
        // <--- 10. ปรับสไตล์ Logo Header
        display: 'flex',
        minHeight: 64,
        px: 1.5,
      }}
    >
      <ListItemButton
        onClick={() => {
          if (open) handleDrawerClose();
          else handleDrawerOpen();
        }}
        sx={{
          minHeight: 48,
          justifyContent: open ? 'initial' : 'center',
          borderRadius: '12px',
        }}
      >
        <ImageListItem sx={{ maxWidth: open ? '40px' : '50px' }}>
          <img src={`${inetlogo}`} />
        </ImageListItem>
        <ListItemText sx={{ opacity: open ? 1 : 0, ml: open ? '15px' : 0 }}>
          <div className="text-sm font-semibold">Internet Thailand</div>
          <div className="text-xs">Public Company Limited</div>
        </ListItemText>
      </ListItemButton>
    </ListItem>
  );

  // --- ส่วนหัว Logo (สำหรับ Mobile) ---
  const mobileLogo = (
    <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
      <ImageListItem sx={{ maxWidth: '60px', mr: 2 }}>
        <img src={inetlogo} alt="INET Logo" />
      </ImageListItem>
      <Box>
        <div className="text-sm font-extrabold">Internet Thailand</div>
        <div className="text-sm">Public Company Limited</div>
      </Box>
    </Box>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      {/* --- 1. DESKTOP SIDEBAR --- */}
      <Hidden smDown>
        <Drawer variant="permanent" open={open}>
          {desktopLogo}
          <Divider sx={{ mx: 2 }} /> {/* <--- 11. เพิ่มเส้นคั่น */}
          {renderMenuItems(
            open, //
            location,
            openListPayment,
            setOpenListPayment,
            openListUsage,
            setOpenListUsage,
            openListStatement,
            setOpenListStatement,
            openListTrans,
            setOpenListTrans,
          )}
          {open && (
            <>
              <Box sx={{ flexGrow: 1 }} /> {/* <--- 12. ตัวดันไปล่างสุด */}
              <Divider sx={{ mx: 2 }} />
              {extraControls}
            </>
          )}
        </Drawer>
      </Hidden>

      {/* --- 2. MOBILE SIDEBAR --- */}
      <Hidden smUp>
        <MuiDrawer
          anchor="left"
          open={openMobile}
          onClose={onMobileClose}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: drawerWidth },
          }}
        >
          {mobileLogo}
          <Divider /> {/* <--- 11. เพิ่มเส้นคั่น (Mobile) */}
          {renderMenuItems(
            true, //
            location,
            openListPayment,
            setOpenListPayment,
            openListUsage,
            setOpenListUsage,
            openListStatement,
            setOpenListStatement,
            openListTrans,
            setOpenListTrans,
          )}
          {/* <ManualSpeedDial /> */}
          <Box sx={{ flexGrow: 1 }} /> {/* <--- 12. ตัวดันไปล่างสุด (Mobile) */}
          <Divider />
          {extraControls}
        </MuiDrawer>
      </Hidden>
    </Box>
  );
}
